import { Translations } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AttributeViewType {
	TILES = 'TILES',
	CHIP = 'CHIP',
}

export interface Attribute extends BaseEntity {
	name: string;
	description: string;
	shopButtonLabel: string;
	viewType: AttributeViewType;
	listOrder: number;
	suffix?: string;
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class AttributeApi extends EntityApi<Attribute> {
	constructor() {
		super(ApiQueryKey.attributes);
	}
}

export default new AttributeApi();
